(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  // if (window.location.pathname === '/collections/all') {
  //   window.location.replace('/');
  // }

  onReady(() => {
    const sliderContainer = document.querySelector('.slider-container');
    if (sliderContainer) {
      let scrollTimer = null;
      sliderContainer.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
          const viewportHeight = window.innerHeight || 1;
          const nextIndex = Math.round(sliderContainer.scrollTop / viewportHeight);
          sliderContainer.scrollTo({
            top: nextIndex * viewportHeight,
            behavior: 'smooth'
          });
        }, 66);
      }, { passive: true });
    }

    const disableSlideCart = () => {
      document.getElementById('slidecarthq')?.remove();
    };

    const noop = () => {};
    window.SLIDECART_OPEN = noop;
    window.SLIDECART_CLOSE = noop;
    window.SLIDECART_UPDATE = noop;
    window.SLIDECART_SET_CART = noop;

    disableSlideCart();

    if (!document.body) return;

    const wrapProductBulletChars = (root = document) => {
      if (!document.body.classList.contains('template-product')) return;
      const scope = root.nodeType === 1 ? root : document;
      const walker = document.createTreeWalker(
        scope,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            if (!node.nodeValue.includes('•')) return NodeFilter.FILTER_REJECT;
            const parent = node.parentElement;
            if (!parent || parent.closest('.tiny-dot')) return NodeFilter.FILTER_REJECT;
            if (/^(SCRIPT|STYLE|NOSCRIPT|CODE|PRE|TEXTAREA|OPTION|TITLE)$/i.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
            if (!parent.closest('.rte, [data-pf-type="ProductDescription"], [data-pf-type="Accordion.Content"]')) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );

      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      nodes.forEach((node) => {
        const parts = node.nodeValue.split('•');
        const fragment = document.createDocumentFragment();
        parts.forEach((part, index) => {
          if (part) fragment.appendChild(document.createTextNode(part));
          if (index < parts.length - 1) {
            const dot = document.createElement('span');
            dot.className = 'tiny-dot';
            dot.textContent = '•';
            fragment.appendChild(dot);
          }
        });
        node.parentNode.replaceChild(fragment, node);
      });
    };

    wrapProductBulletChars();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if ([...mutation.addedNodes].some((node) => node.nodeType === 1 && (node.id === 'slidecarthq' || node.querySelector?.('#slidecarthq')))) {
          disableSlideCart();
          break;
        }
      }
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) wrapProductBulletChars(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(() => observer.disconnect(), 15000);
  });
})();
